import { headerPersonaCharm_ariaLabel } from './HeaderPersona.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';
import PersonaControl from 'owa-persona/lib/components/PersonaControl';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

import { MeCardPane } from 'owa-header-pane';
import { PersonaSize } from 'office-ui-fabric-react/lib/Persona';
import { observer } from 'mobx-react-lite';
import HeaderCharm from './HeaderCharm';
import { HeaderCharmType } from 'owa-header-store';

const HeaderPersona = observer(function HeaderPersona(props: {}) {
    const userConfiguration = getUserConfiguration();

    const emailAddress = userConfiguration.SessionSettings.UserEmailAddress;

    return (
        <HeaderCharm
            title={loc(headerPersonaCharm_ariaLabel)}
            ariaLabel={loc(headerPersonaCharm_ariaLabel)}
            icons={{
                charmContent: (
                    <PersonaControl
                        name={userConfiguration.SessionSettings.UserDisplayName}
                        emailAddress={emailAddress}
                        secondaryText={emailAddress}
                        size={PersonaSize.size32}
                        hexConsumerIdForUser={userConfiguration.HexCID}
                    />
                ),
            }}
            behavior={{
                charm: HeaderCharmType.PersonaCharm,
                paneComponent: MeCardPane,
            }}
        />
    );
});
export default HeaderPersona;
